const ACCESS_PAGE = '/access#applicant-access';
const WORKFORCE_SIGN_IN = /^\/workforce\/[a-z0-9](?:[a-z0-9-]{0,78}[a-z0-9])?\?sign_in=1$/;

export function uploadContinuationHref(continuation) {
  if (continuation === null) return null;
  if (continuation?.requires_sign_in === true && WORKFORCE_SIGN_IN.test(continuation.href)) {
    return continuation.href;
  }
  // Unknown/missing metadata may only lead to ordinary secure sign-in.
  return ACCESS_PAGE;
}

export function assertUploadReceived(data) {
  if (data?.status !== 'success' || typeof data.document_id !== 'string' || !data.document_id.trim()) {
    throw new Error('Upload receipt was not confirmed');
  }
  return data;
}

export function publicUploadErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (typeof detail?.message === 'string' && detail.message.trim()) return detail.message;
  return fallback;
}

export const UNCONFIRMED_UPLOAD = 'We could not confirm whether this file was received. Open CareOps to check before uploading it again.';
